import { Field } from 'formik';
import React from 'react';
import { NumberFormatValues } from 'react-number-format';
import { BoldHeader4Text, DateField, FormCell, Grid, GridItem, NumberInputStyled, PhoneNumberField } from 'ui-toolkit';
import { showError } from '../../../../../utilities/order/showError';
import { IPartySchema, useFocusTrackingState } from '../../../../../state';
import { PartyTypeSelector } from './PartyTypeSelector';
import { TextFieldTW } from '../../../../../tailwindComponents/textInputTW/TextFieldTW';
import { MaritalStatusCreatable } from '../../../../orderCreation/parties/MaritalStatusCreatable';
import { EditAddressDataEntry } from '../../../../../ui-toolkit/orders/components/EditPropertyAddress/EditAddressDataEntry';
import { IFieldChildProps } from '../../../../../ui-toolkit/utilities/formikUtilities';

interface IEditPersonDataEntryProps {
  isNew: boolean;
}

export const EditPersonDataEntry: React.FC<IEditPersonDataEntryProps> = ({ isNew }) => {
  const [focus, setFocus] = useFocusTrackingState();
  const onPartyTypeChange = () => setFocus({ doesAnyone: true, index: -1 });
  return (
    <Grid columnCount={12}>
      {isNew ? <PartyTypeSelector onPartyTypeChange={onPartyTypeChange} /> : null}
      <TextFieldTW
        name={'first_name'}
        data-test-id={'first_name'}
        className={'col-span-4'}
        labelText={'First Name'}
        placeholder={'Johnny'}
        isRequired
        autoFocus={focus.doesAnyone && focus.index === -1}
      />
      <TextFieldTW
        name={'middle_name'}
        data-test-id={'middle_name'}
        className={'col-span-4'}
        labelText={'Middle Name'}
        placeholder={'"L" or "Leroy"'}
      />
      <TextFieldTW
        name={'last_name'}
        data-test-id={'last_name'}
        className={'col-span-4'}
        labelText={'Last Name'}
        placeholder={'Appleseed'}
        isRequired
      />
      <GridItem columnStart={'span 3'}>
        <Field
          name={`ssn`}
          render={({ field, form }: IFieldChildProps<string, IPartySchema>) => (
            <FormCell label={`Last 4 Digits Of SSN`} errorText={showError(form, field.name)} isRequired={false}>
              <NumberInputStyled
                {...field}
                allowEmptyFormatting={false}
                format={`XXX-XX-####`}
                type={'tel'}
                placeholder={'XXX-XX-####'}
                mask={`#`}
                onValueChange={({ value }: NumberFormatValues) => {
                  form.setFieldValue(field.name, value ? value.trim() : value);
                }}
                onChange={() => void 0}
              />
            </FormCell>
          )}
        />
      </GridItem>
      <MaritalStatusCreatable
        name={'marital_status'}
        className={'col-span-3'}
        placeholder={'Married, Unmarried, etc...'}
        labelText={`Marital Status`}
      />
      <TextFieldTW
        name={'email'}
        data-test-id={'email'}
        labelText={'Email'}
        placeholder={'johnnylappleseed@gmail.com'}
        className={'col-span-3'}
      />
      <div className={'col-span-3'}>
        <PhoneNumberField name={`phone_number`} label={`Phone Number`} data-test-id={`phone_number`} />
      </div>
      <GridItem columnStart={'span 3'}>
        <DateField name={'date_of_birth'} label={`Date of Birth`} placeholder={`MM/DD/YYYY`} />
      </GridItem>
      <GridItem columnStart={'span 12'}>
        <BoldHeader4Text>Current Address</BoldHeader4Text>
      </GridItem>
      <GridItem columnStart={'span 12'}>
        <EditAddressDataEntry name={'address'} />
      </GridItem>
    </Grid>
  );
};
